import { getCurrentInstance } from 'vue'


export function useStore() {
  const { proxy } = getCurrentInstance();
  const store = proxy.$store;
  return store;
}

export function useIns() {
  const { proxy } = getCurrentInstance();
  return proxy;
}

export function use18n() {
  const { proxy } = getCurrentInstance();
  const $t = proxy.$t.bind(proxy);
  const $p = proxy.$p.bind(proxy);
  const $pid = proxy.$pid.bind(proxy);
  const $n = proxy.$n.bind(proxy);
  const { locale } = proxy.$i18n;
  return { $t, $p, $pid, $n, locale };
}
